/**
 * Parses the brief ID from a brief key parameter.
 * @param briefKey The briefKey used in brief urls
 * @param allowNaN If true, will return NaN if the brief ID cannot be parsed instead of throwing an error
 * @returns The parsed brief ID
 */
export const parseBriefIdFromBriefKeyParam = (briefKey: string, allowNaN = false): number => {
  const briefIdParsed = briefKey.split('-').at(-1);
  const briefId = parseInt(briefIdParsed ?? '', 10);

  if (Number.isNaN(briefId) && !allowNaN) {
    throw new Error(`Could not parse brief ID from brief key: ${briefKey}`);
  }

  return briefId;
};

/**
 * Creates the properly structured URL for a brief
 * @param owner - The owner of the brief without the "@" prefix. This will be either the account.name or group/org.shorthand property.
 * @param key - The brief key
 * @param id - The brief ID
 * @returns The brief URL
 */
export const createBriefUrlPath = (owner: string, key: string, id: number): string => {
  return `/@${owner}/${key}-${id}`.replaceAll(' ', '-').toLowerCase();
};
